import { DatasetDurationLimiter } from "@/services/license/license-limiters/base-limiters/dataset-duration-limiter";
import { LicenseName } from "@/data/license.data";
import { getUserUniqueCustomVoiceDatasetLimit } from "@/actions/db/user-unique-dataset-limits";
import { IsDatasetLimitedResult } from "@/services/license/base/license-manager-abstractions";

export const trialDatasetMinutesLength = 3;
export const starterDatasetMinutesLength = 5;
export const creatorDatasetMinutesLength = 15;
export const studioDatasetMinutesLength = 30;

export class CustomVoiceDatasetDurationLimiter extends DatasetDurationLimiter {
  async isDatasetDurationLimited(
    userId: string,
    license: LicenseName,
    seconds: number,
  ): Promise<IsDatasetLimitedResult> {
    const limit = await this.getLimit(userId, license);
    return { isLimited: seconds / 60 >= limit, limit: limit };
  }

  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Basic":
        return starterDatasetMinutesLength;
      case "Starter":
        return starterDatasetMinutesLength;
      case "Creator":
        return creatorDatasetMinutesLength;
      case "Studio":
        return studioDatasetMinutesLength;
      case "Premium":
        return studioDatasetMinutesLength;
      default:
        return trialDatasetMinutesLength;
    }
  }

  getUniqueLimit(userId: string): Promise<number | null> {
    return getUserUniqueCustomVoiceDatasetLimit(userId);
  }
}
